import { inject, Injectable, signal } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { API_ROOT } from "../types/constants/appconstants";
import { OAuthStorage } from "angular-oauth2-oidc";
import { IHttpConnectionOptions } from "@microsoft/signalr";
import { UserNotification } from '../types';
import { AuthService } from './data/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  private apiRoot: string = inject(API_ROOT)
  #authStorage: OAuthStorage = inject(OAuthStorage)
  private authService: AuthService = inject(AuthService)
  private customerPortalHubEndpoint: string = 'customerPortal';

  private _cxUnreadMessages = signal<UserNotification | null>(null);
  cxUnreadMessages = this._cxUnreadMessages.asReadonly();

  private customerPortalHubConnection: signalR.HubConnection;
  private options: IHttpConnectionOptions = {
    accessTokenFactory: () => this.#authStorage.getItem('access_token'),
    withCredentials: true,
    skipNegotiation: false
  }

  constructor() { }

  public connectToCustomerPortalMessages = () => {
    this.customerPortalHubConnection = this.createHub(this.customerPortalHubEndpoint)
    this.bindCustomerPortalMessages();
    this.startHub(this.customerPortalHubConnection);
  }

  private createHub(hubEndpoint: string): signalR.HubConnection {
    return new signalR.HubConnectionBuilder()
      .withUrl(`${this.apiRoot}${hubEndpoint}`, this.options)
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }

  private bindCustomerPortalMessages() {
    this.customerPortalHubConnection.on("MessageUpdate", (message: UserNotification) => {
      this._cxUnreadMessages.set(message);
    });
  }

  private startHub(hub: signalR.HubConnection) {
    hub.start()
      .then(() => console.log('SignalR Connection started'))
      .catch(err => console.log('Error establishing SignalR connection: ' + err));
  }

}
